import { EllipsedText, FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { memo } from 'react';
import { useSetRecoilState } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { selectedJourneyIdState } from '../../storage/journeys';
import { Journey } from '../../types/journey';
import { getAssetTitle } from '../../utils/assets';
import { getJourneyStatus } from '../../utils/journeys';
import { StyledTooltip } from '../ui/StyledTooltip';

type Props = {
  journey: Journey;
};

function JourneyCardHeader({ journey }: Props) {
  const { css, theme } = useStyles();
  const { asset } = journey;
  const setSelectedJourneyId = useSetRecoilState(selectedJourneyIdState);

  const status = getJourneyStatus(journey.status);

  const onEditJourney = () => {
    setSelectedJourneyId(journey._id);
  };

  return (
    <FlexRow
      classNames={css({
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.sizing.scale300} ${theme.sizing.scale500}`,
      })}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        centered
      >
        {status && (
          <StyledTooltip content={status.name}>
            <MaterialIcon
              name={status.icon}
              size="compact"
              color={status.color}
            />
          </StyledTooltip>
        )}
        {asset && (
          <>
            <LabelMedium>
              <EllipsedText
                inline
                breakAll
              >
                {getAssetTitle(asset)}
              </EllipsedText>
            </LabelMedium>
            <StyledTooltip content="Etiqueta">
              <ParagraphSmall
                margin={0}
                color={theme.colors.contentSecondary}
              >
                <EllipsedText
                  inline
                  breakAll
                >
                  {`(${asset.label || '-'})`}
                </EllipsedText>
              </ParagraphSmall>
            </StyledTooltip>
          </>
        )}
        {!asset && <LabelMedium>-</LabelMedium>}
      </FlexRow>
      <Button
        shape="circle"
        size="mini"
        kind="tertiary"
        onClick={onEditJourney}
      >
        <MaterialIcon
          name="edit"
          size="mini"
        />
      </Button>
    </FlexRow>
  );
}

export default memo(JourneyCardHeader);
